// extracted by mini-css-extract-plugin
export default {"loading":"_557ighmlc5yBiCNt9P1lwe"};